export default __webpack_public_path__ + "static/media/MaskGroup3.308f5804.png";